module.exports = __webpack_public_path__ + "static/img/img-install-tag-bus.724cc0e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/install-guide/img-install-tag-bus.svg
// module id = 1786
// module chunks = 1